import { ToggleButton } from "../StoryPreview";
import { useConsole, useUser } from "contexts";
import PropTypes from "prop-types";
import { MoreItem } from "./MoreButton";

function FirebaseButton({ mode, onClose, story }) {
  const { hasPermission } = useUser();
  const { screen } = useConsole();

  if (!hasPermission("database:read") || screen.isMobile) return null;

  const handleClick = () => {
    window.open(`${process.env.MONUS_DATABASE}${story._id}`);
  };

  if (mode === "menu") {
    return (
      <MoreItem
        icon="storage"
        onClick={() => {
          handleClick();
          onClose();
        }}
      >
        Firebase
      </MoreItem>
    );
  }

  return (
    <ToggleButton icon="open_in_new" label="Firebase" onClick={handleClick} />
  );
}

FirebaseButton.propTypes = {
  mode: PropTypes.oneOf(["button", "menu"]),
  onClose: PropTypes.func,
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
};

export default FirebaseButton;
